import { useState } from 'react';

var useComponentId = function (prefix) {
  var now = useState(Date.now())[0];
  return "".concat(prefix, "-").concat(now);
};

export { useComponentId as default };
